<template>
	<div>
    <div class="tab">
      <ul class="tab-container">
        <li class="tab-item" v-for="(item, index) in items" :key="index" @click="OnClick(index)">
          <div class="tab-item-icon" v-if="item.icon"><i :class="item.icon"></i></div>
          <a class="tab-item-link" :class="index === selectedIndex ? 'active' : ''">{{item.title}}</a>
        </li>
      </ul>
    </div>
    <slot></slot>
	</div>
</template>

<script>
export default {
	props: {
		items:Array,
		selectedIndex:Number
	},
	methods: {
		OnClick:function(idx) {
			this.$emit('update:selectedIndex', idx);
			this.$emit('OnChangeTab', idx);
		}
	}
}
</script>

<style scoped>
.tab {
  display: -webkit-flex;
  display: flex;
}
.tab ul,
.tab li {
  list-style: none;
  padding-left: 0;
}
.tab-container {
  overflow: auto;
  overflow-y: hidden;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  display: -webkit-flex;
  display: flex;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.tab-item {
  cursor: pointer;
  display: -webkit-flex;
  display: flex;
  -webkit-flex-flow: column;
  flex-flow: column;
  align-items: center;
  margin-right: 1rem;
  margin-bottom: 10px;
  text-transform: uppercase;
  font-weight: bold;
}
.tab-item-icon {
  font-size: 32px;
}
.tab-item-link {
  position: relative;
  transition: all 0.2s ease;
  color: rgba(0, 0, 0, 0.3);
  font-size: 0.9em;
}
.tab-item:hover * {
  color: #001b3d;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.tab-item-link.active {
  color: #001b3d;
}
.tab-item-link:after {
  content: "";
  width: 0%;
  height: 2px;
  background-color: #001b3d;
  position: absolute;
  bottom: -10px;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.tab-item-link.active:after {
  width: 100%;
}
</style>
